export const GET_LINK = "GET_LINK";